import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const Footer = () => {
  const [showCredits, setShowCredits] = useState(false);

  const handleCloseCredits = () => setShowCredits(false);
  const handleShowCredits = () => setShowCredits(true);
  return (
    <>
      <style jsx="true">{`
        .modal-md {
          max-width: 50% !important;
          margin: 0 auto;
        }
        @media only screen and (max-width: 768px) {
          .modal-md {
            max-width: 95% !important;
            margin: 0 auto;
          }
        }
      `}</style>
      <div
        style={{
          padding: "50px",

          background: "rgb(238,238,238)",
          background:
            " linear-gradient(180deg, rgba(238,238,238,1) 0%, rgba(186,182,182,1) 100%)",
          position: "relative",
          zIndex: "999",
        }}
        className="text-center"
      >
        <p>Non commercial purposes</p>
        <p style={{ cursor: "pointer" }} onClick={handleShowCredits}>
          Credits
        </p>
        <p>This site demostrate the effects 3D in website</p>
        <p>Created by SOWEME</p>
        <p>hello.soweme@gmail.com</p>
      </div>
      <Modal
        show={showCredits}
        onHide={handleCloseCredits}
        style={{ zIndex: "99991" }}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Credits</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            "Vuzix Blade Smart Glasses" (https://skfb.ly/ 6SAOQ) by Alex Ru is
            licensed under Creative Commons Attribution
            (http://creativecommons.org/ licenses/by/4.0/).
          </p>
          <p>
            "Free Sunglasses Set (LowPoly)" (https://skfb.ly/ 6S7vr) by Berk
            Gedik is licensed under Creative Commons Attribution
            (http://creativecommons.org/ licenses/by/4.0/).
          </p>

          <p>
            "Ray Ban Glasses" (https://skfb.ly/oprKn) by Agha.Najam is licensed
            under Creative Commons Attribution (http://creativecommons.org/
            licenses/by/4.0/).
          </p>
          <p>
            "Reservoir Dogs' glasses - SGP26" (https://skfb.ly/ JEnQ) by JuanG3D
            is licensed under Creative Commons Attribution
            (http://creativecommons.org/ licenses/by/4.0/).
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseCredits}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Footer;
